export default "/images/vendor/flag-icon-css/flags/1x1/do.svg?64a9810e7d07e3af7412bee6afe85102";